import { EntityType } from 'api'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { createEntitySelector } from 'selectors/entitySelectors'
import { isNotNil } from 'utils/predicate'
import {
  authorisedUserIsPermissionedToTradeInstrumentSelector,
  instrumentIsPermittedToBePrimarySelector,
  instrumentCanBeTradedByAuthorisedUserSelector,
  createInstrumentCanBeTradedByTradingEntitySelector
} from './instrumentFilterSelectors'

export const createInstrumentFiltersForFundSelector = <P>(fundIdSelector: Selector<{}, string | null | undefined, [P]>) =>
  createSelector(
    [
      createEntitySelector(fundIdSelector, EntityType.TRADING_ENTITY),
      instrumentCanBeTradedByAuthorisedUserSelector,
      authorisedUserIsPermissionedToTradeInstrumentSelector,
      createInstrumentCanBeTradedByTradingEntitySelector,
      instrumentIsPermittedToBePrimarySelector
    ],
    (
      fund,
      instrumentCanBeTradedByAuthorisedUser,
      authorisedUserIsPermissionedToTradeInstrument,
      createInstrumentCanBeTradedByTradingEntities,
      instrumentIsPermittedToBePrimary
    ) => [
      instrumentCanBeTradedByAuthorisedUser(),
      instrumentIsPermittedToBePrimary,
      authorisedUserIsPermissionedToTradeInstrument,
      ...(isNotNil(fund) ? [createInstrumentCanBeTradedByTradingEntities(null, [fund.id])] : [])
    ]
  )
